










import Vue from 'vue'
import { titleize } from 'underscore.string'

export default Vue.extend({
  name: "admin-page",
  props: {
    resource: {
      type: String,
      default: null
    }
  },

  computed: {
    title():string { return titleize(this.resource) }
  },

  methods: {

  },

  filters: {
    titleize(string):string {
      return titleize(string)
    }
  },

  created() {

  },
  mounted() {

  },
  updated() {
    
  }
})
